import { debounceTime } from 'rxjs/operators';
import { Component, Input, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'number-picker',
  templateUrl: './number-picker.component.html',
  styleUrls: [ './number-picker.component.scss' ]
})
export class NumberPickerComponent implements OnInit {

  @Input() changeChannel: Subject<any>;
  @Input() context: any;
  @Input() prop: string;
  @Input() min: number = 0;
  @Input() max = 99;

  formControl: FormControl = new FormControl();

  ngOnInit(): void {
    this.formControl.patchValue(this.context[this.prop]);

    this.formControl.valueChanges.pipe(
      debounceTime(500))
      .subscribe((value: number) => {
        this.changeChannel.next(value);
      });
  }

  increment() {
    if (this.context[this.prop] < this.max) {
      this.context[this.prop] += 1;
      this.formControl.patchValue(this.context[this.prop]);
    }
  }

  decrement() {
    if (this.context[this.prop] > this.min) {
      this.context[this.prop] -= 1;
      this.formControl.patchValue(this.context[this.prop]);
    }
  }
}
